import type React from 'react';

import { Button } from '@change/ds-core-ui';
import { CloseIcon } from '@change/ds-icons';

import { Translate, TypedTranslate, useI18n } from '@change-corgi/core-react/i18n';
import { InlineMessage } from '@change-corgi/design-system-legacy/components/alerts';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';

import { ImageCropperUploaderSunriseV2 as ImageCropperUploader } from 'src/app/shared/components/imageUpload';
import { Media as MediaComponent } from 'src/app/shared/components/media';

import { useMedia } from './hooks/useMedia';

export const Media: React.FC = () => {
	const { data, actions } = useMedia();
	const { translate } = useI18n();

	return (
		<div id="add_media">
			{data.media ? (
				<Flex sx={{ flexDirection: 'column', gap: 8 }}>
					<Box
						sx={{
							position: 'relative',
							borderRadius: 'standard',
							overflow: 'hidden',
							width: '100%',
							aspectRatio: '16/9',
						}}
					>
						<MediaComponent media={data.media} shape="rectangle" />
						<Button
							size="x-small"
							variant="secondary-solid"
							iconOnly
							leadingIcon={<CloseIcon size="small" />}
							aria-label={translate('corgi.petition.edit.petition_content.image.remove_image_button')}
							onClick={actions.handleRemoveMedia}
							className="absolute top-4 right-4"
							data-qa="remove-media-button"
						/>
					</Box>
				</Flex>
			) : (
				<>
					<ImageCropperUploader
						image={data.image}
						uploader={data.uploader}
						onImageChange={actions.handleImageChange}
						onImageCrop={actions.handleImageCrop}
						onCancelClick={actions.handleCancelUpload}
					/>
					{data.error ? (
						<InlineMessage size="small" fontWeight="normal" variant="warning" mt={8} data-testid="upload-error-message">
							<TypedTranslate value={data.error} />
						</InlineMessage>
					) : (
						<InlineMessage size="small" fontWeight="normal" mt={8} sx={{ span: { fontWeight: 400 } }}>
							<Translate value="corgi.petition.edit.petition_content.image.default_image_message" />
						</InlineMessage>
					)}
				</>
			)}
		</div>
	);
};
